import { render, staticRenderFns } from "./jaUserProtocol.vue?vue&type=template&id=93d13244&scoped=true&"
import script from "./jaUserProtocol.vue?vue&type=script&lang=js&"
export * from "./jaUserProtocol.vue?vue&type=script&lang=js&"
import style0 from "./jaUserProtocol.vue?vue&type=style&index=0&id=93d13244&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d13244",
  null
  
)

export default component.exports